export default "__VITE_ASSET__DeBTArwJ__"